export default __webpack_public_path__ + "static/media/logo.3cde5d19.svg";